import React, { useEffect, useMemo, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Messages from '../molecules/Messages';
import { Content } from '../types/Template';
import axios from 'axios';
import { KeyValueType } from '../types/KeyValue';

export type UserInfoSubmitReceptionProps = {
  contents: Content[];
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
};

const UserInfoSubmitReception = ({ contents, setContents }: UserInfoSubmitReceptionProps) => {
  const [masterBranches, setMasterBranches] = useState<KeyValueType[]>([]);

  const getContentByFieldColumnName = (fieldColumnName: string): Content | undefined => {
    const indexOfFieldColumnName = contents?.findIndex(
      (content) => content.field_column_name === fieldColumnName
    );
    return contents[indexOfFieldColumnName];
  };

  const setContentByFieldColumnName = (fieldColumnName: string, cb: (content: Content) => void) => {
    const indexOfFieldColumnName = contents?.findIndex(
      (content) => content.field_column_name === fieldColumnName
    );
    setContents((prevContent) => {
      const newContent = [...prevContent];
      newContent?.[indexOfFieldColumnName] && cb(newContent[indexOfFieldColumnName]);
      return newContent;
    });
  };

  const handleOnBlurByFieldColumnName = (fieldColumnName: string) => async () => {
    try {
      await axios.get(`/api/user_submit/check`, {
        params: getContentByFieldColumnName(fieldColumnName),
      });
      setContentByFieldColumnName(fieldColumnName, (content) => (content.message = undefined));
    } catch (error) {
      if (error?.response?.status === 422) {
        setContentByFieldColumnName(
          fieldColumnName,
          (content) => (content.message = error?.response?.data?.message)
        );
      }
    }
  };

  const emailContent = useMemo(() => getContentByFieldColumnName('email'), [contents]);
  const branchContent = useMemo(() => getContentByFieldColumnName('branch'), [contents]);

  useEffect(() => {
    axios.get<KeyValueType[]>(`/api/masters/branches`).then((res) => setMasterBranches(res.data));
  }, []);

  return (
    <Row className="col-10 col-lg-9 mx-auto py-2">
      {/* --- email --- */}
      <Col xs="6">
        <Form.Group id="email">
          <Form.Label>メールアドレス</Form.Label>
          <Form.Control
            disabled={emailContent?.disabled}
            value={emailContent?.value}
            maxLength={255}
            onChange={(e) =>
              setContentByFieldColumnName('email', (content) => (content.value = e?.target?.value))
            }
            onBlur={handleOnBlurByFieldColumnName('email')}
          />
          <Messages valid_msg={emailContent?.message} />
        </Form.Group>
      </Col>
      {/* --- branch --- */}
      {!branchContent?.hidden && (
        <Col xs="6">
          <Form.Group id="branch">
            <Form.Label>店舗</Form.Label>
            <Form.Select
              disabled={branchContent?.disabled}
              value={branchContent?.value}
              onChange={(e) =>
                setContentByFieldColumnName(
                  'branch',
                  (content) => (content.value = e?.target?.value)
                )
              }
              onBlur={handleOnBlurByFieldColumnName('branch')}
            >
              <option></option>
              {masterBranches?.map((masterBranch) => (
                <option key={masterBranch?.key} value={masterBranch?.key}>
                  {masterBranch?.value}
                </option>
              ))}
            </Form.Select>
            <Messages valid_msg={branchContent?.message} />
          </Form.Group>
        </Col>
      )}
    </Row>
  );
};

export default UserInfoSubmitReception;
